import { AnalyticsContext } from '@jetshop/core/analytics/AnalyticsProvider';
import { useContext, useEffect, useCallback, useRef } from 'react';
import throwErrorInDev from '../helpers/throwErrorInDev';
import { useLocation } from 'react-router';
function Analytics(props) {
    const track = useTracker();
    useEffect(() => {
        if (props.event) {
            track(props.event);
        }
        // Here be dragons!
        // Optimally we would pass track and props.track here, to make sure this
        // effect runs if the props change. However, props.track returns a new
        // function every time, so it always differs, and this effect runs multiple
        // times <Analytics track={trackProduct({ action: 'view', product })} /> To
        // fix this, the object passed to trackProduct would need to be memoized,
        // but we can't rely on design partners doing that correctly…
        // eslint-disable-next-line
    }, [track]);
    if (!props.children)
        return null;
    return props.children;
}
function useTracker() {
    const { trackerRegistry, config } = useContext(AnalyticsContext);
    const location = useLocation();
    const locationState = useRef(location.state);
    return useCallback(({ name, payload, id }) => {
        try {
            if (typeof name !== 'string') {
                throw new Error('"name" is required');
            }
            // Please fix me
            if (!config.trackingAllowed) {
                (payload === null || payload === void 0 ? void 0 : payload.callback) && (payload === null || payload === void 0 ? void 0 : payload.callback());
                return null;
            }
            const context = {
                trackerRegistry,
                list: locationState.current ? locationState.current.list : null,
                emit: (str, payload) => {
                    trackerRegistry.emit(str, payload, context, id);
                }
            };
            trackerRegistry.emit(name, payload, context, id);
        }
        catch (err) {
            throwErrorInDev(true, `Analytics error on "${name}"-event:`, {
                err,
                payload
            });
        }
    }, [trackerRegistry, config.trackingAllowed]);
}
export default Analytics;
export { useTracker };
//# sourceMappingURL=Analytics.js.map